export enum Type {
  Paint = 0,
  NonPaint = 1,
}
